module.exports = __webpack_public_path__ + "img/france-infectious-diseases-female.31a4236c.png";